module.exports = __webpack_public_path__ + "static/img/dna_gif_transparent.ad314066.gif";